import { TopBarProps } from '~/components/TopBar/models';
import { InfoBar } from '~/mappers/infoBar/models';
import { isShoppingCart } from '~/utils/bodyWithShoppingCartData';

export const infoBarMapper = ({
  messages,
  ariaLabels,
  showInfoBar,
  isVisibleOnCartPage,
  changeInterval,
  body,
}: InfoBar): TopBarProps => ({
  messages,
  ariaLabels,
  showInfoBar: isShoppingCart(body)
    ? showInfoBar && messages.length > 0 && isVisibleOnCartPage
    : showInfoBar && messages.length > 0,
  intervalTime:
    changeInterval && changeInterval.length > 0
      ? Number(changeInterval)
      : undefined,
});
